import { API_URL } from "../api"

export const correctPhotoLink = (link: string | undefined) => {
    if(!link) return link
    if (link?.includes('http')) {
        return link
    } else {
        return `${API_URL}${link}`
    }
}